import { forwardRef } from 'react';

import { InputLabel } from '@/components/input-label';

import styles from './Textarea.module.css';

interface TextareaProps {
  onChange?: (Textarea: TypeAny) => TypeAny;
  placeholder?: string | null;
  children?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  defaultValue?: string;
  value?: string;
  label?: string;
  name: string;
  fullWidth?: boolean;
}

const Textarea = forwardRef(
  (
    {
      placeholder,
      children,
      disabled,
      required,
      onChange,
      defaultValue,
      value,
      label,
      name,
      fullWidth
    }: TextareaProps,
    ref: React.LegacyRef<HTMLTextAreaElement>
  ) => {
    const textareaId = `textarea-${name}`;

    return (
      <label className={styles.textarea} data-full-width={fullWidth} htmlFor={textareaId}>
        {label && (
          <span className={styles.textareaLabel}>
            <InputLabel required={required} label={label} />
          </span>
        )}

        <textarea
          placeholder={placeholder || undefined}
          className={styles.textareaElement}
          data-testid="textareaElement"
          defaultValue={defaultValue}
          onChange={onChange}
          required={required}
          disabled={disabled}
          id={textareaId}
          name={name}
          ref={ref}
          rows={4}
        >
          {value}
        </textarea>

        {children}
      </label>
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
